import { useEffect, useState } from 'react';
import Content from '../Section/Content';
import { HeaderSearch } from '../Section/HeaderSearch';

const ThemeThree = ({ attributes , setAttributes }) => {

    const { faqData = [] } = attributes || {};

    const [searchTerm, setSearchTerm] = useState("");
    const [filteredFaqs, setFilteredFaqs] = useState(faqData);

    useEffect(() => {
        let list = faqData || [];

        if (searchTerm && searchTerm.trim() !== "") {
            const q = searchTerm.toLowerCase();
            list = list.filter(
                (f) =>
                    (f.question || "").toLowerCase().includes(q) ||
                    (f.answer || "").toLowerCase().includes(q)
            );
        }

        setFilteredFaqs(list);
    }, [faqData, searchTerm]);


    return (
        <div className='ThemeThreeWrapper faq-container-style'>
            <HeaderSearch
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
            />
            <Content
                faqs={filteredFaqs}
                attributes={attributes}
                setAttributes={setAttributes}
            />
        </div>
    )
}

export default ThemeThree;